// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qrYPj","col":"styles_col__1stnB"};